import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit() {
  }

  public onFeedbackClick(){
        this.router.navigate(['login']);
    }

 public onInterviewClick(){
        this.router.navigate(['interview']);
    }
}



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/homepage/homepage.component.ts